import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Button from '../../../src/components/pages/ui/Button/Button';
import './KvSubSimple.scss';

export default function KvSubSimple({ fields, buttonConfig }) {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (item) => {
    let result = '';

    if (item && item.fields) {
      const getImageUrlFromField = (imageField) => {
        if (!imageField?.fields) return '';

        if (isMobile) {
          return (
            imageField.fields.mobileImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            ''
          );
        } else if (isTablet) {
          return (
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        } else {
          return (
            imageField.fields.desktopImage?.value?.src ||
            imageField.fields.tabletImage?.value?.src ||
            imageField.fields.mobileImage?.value?.src ||
            ''
          );
        }
      };

      result = getImageUrlFromField(item.fields.image);

      return result;
    }

    return result;
  };

  const getButton = (item) => {
    if (item && item.fields) {
      const buttonPath = item.fields.buttonPath?.value;
      const buttonText = item.fields.buttonText?.value;
      const query = buttonPath?.querystring || '';

      if (buttonPath || buttonText) {
        return {
          path:
            buttonPath.href || buttonPath.url || buttonConfig?.defaultButtonPath
              ? (buttonPath.href || buttonPath.url || buttonConfig?.defaultButtonPath) + query
              : '#',
          text: buttonText || '',
          target: buttonPath.target || '_self',
        };
      }
    }
    return null;
  };

  const button = getButton({ fields });

  return (
    <div className="KvSubSimpleComp">
      <div className="KvSubSimpleIn">
        <section className="KvSubSimple__img">
          <img src={getImageUrl({ fields })} alt="" />
        </section>

        <section className="KvSubSimple__left">
          <div dangerouslySetInnerHTML={{ __html: fields.title?.value }}></div>
        </section>

        <section className="KvSubSimple__right">
          {button && (
            <Button className="KvSubSimple_button" isShowTooltip={false} target={button.path}>
              {button.text}
            </Button>
          )}
        </section>
      </div>
    </div>
  );
}
